/* eslint-disable react/display-name */
import * as React from "react"
import { styled } from "@mui/material/styles"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

import Links from "./Links"

const createLogoStyled = (isCollapse) =>
    styled("span")(() => ({
        whiteSpace: "nowrap",
        overflow: isCollapse ? "hidden" : "visible",
        WebkitLineClamp: "1",
        display: "block",
        padding: `15px ${isCollapse ? "10px" : "22px"}`,
        textOverflow: "ellipsis",
        textAlign: isCollapse ? "center" : "left",
    }))

const LogoBox = styled(Box)({
    objectFit: "contain",
    transition: "width 0.2s ease-in-out",
})

const Logo = React.memo(
    ({ children, img, href = "/", component, isCollapse }) => {
        const LogoStyled = React.useMemo(
            () => createLogoStyled(isCollapse),
            [isCollapse],
        )

        const imageProps = React.useMemo(
            () => ({
                width: isCollapse ? 34 : 182,
                height: 34,
                src: img,
                loading: "eager",
                decoding: "async",
                // Adicionar id para evitar recargas desnecessárias
                id: `logo-img-${isCollapse ? "collapsed" : "expanded"}`,
            }),
            [img, isCollapse],
        )

        const logoContent = React.useMemo(() => {
            if (img === "") {
                return <Typography variant="body1">{children}</Typography>
            } else {
                return <LogoBox component="img" {...imageProps} />
            }
        }, [img, children, imageProps])

        return (
            <Links href={href} component={component} to={href}>
                <LogoStyled>{logoContent}</LogoStyled>
            </Links>
        )
    },
    // Função de comparação personalizada para o React.memo
    (prevProps, nextProps) => {
        // Só re-renderizar se estas props mudarem
        return (
            prevProps.img === nextProps.img &&
            prevProps.isCollapse === nextProps.isCollapse &&
            prevProps.children === nextProps.children
        )
    },
)

export { Logo }
